class MCartDrawer extends HTMLElement {
	constructor() {
		super(),
			(this.cartDrawerInner = this.querySelector(
				".m-cart-drawer__inner"
			)),
			(this.cartDrawerCloseIcon = this.querySelector(
				".m-cart-drawer__close"
			)),
			(this.cartOverlay = this.querySelector(".m-cart__overlay")),
			(this.rootUrl = window.Shopify.routes.root),
			this.setHeaderCartIconAccessibility(),
			this.cartDrawerCloseIcon.addEventListener(
				"click",
				this.close.bind(this)
			),
			this.addEventListener("click", (e) => {
				e.target.closest(".m-cart-drawer__inner") !==
					this.cartDrawerInner && this.close();
			});
	}
	setHeaderCartIconAccessibility() {
		document.querySelectorAll(".m-cart-icon-bubble").forEach((e) => {
			e.setAttribute("role", "button"),
				e.setAttribute("aria-haspopup", "dialog"),
				e.addEventListener("click", (t) => {
					MinimogSettings.enable_cart_drawer &&
						(t.preventDefault(), this.open(e));
				});
		});
	}
	open(e) {
		e && this.setActiveElement(e),
			this.classList.add("m-cart-drawer--active"),
			requestAnimationFrame(() => {
				this.style.setProperty("--m-bg-opacity", "0.5"),
					this.cartDrawerInner.style.setProperty(
						"--translate-x",
						"0"
					);
			}),
			window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer),
			document.documentElement.classList.add("prevent-scroll");
		this.initializeUpsellSection();
	}
	close() {
		this.style.setProperty("--m-bg-opacity", "0"),
			this.cartDrawerInner.style.setProperty("--translate-x", "100%"),
			setTimeout(() => {
				this.classList.remove("m-cart-drawer--active"),
					document.documentElement.classList.remove("prevent-scroll");
			}, 300);
	}
	renderContents(e) {
		this.classList.contains("m-cart--empty") &&
			this.classList.remove("m-cart--empty"),
			(this.productId = e.id),
			this.getSectionsToRender().forEach((t) => {
				(t.selector
					? document.querySelector(t.selector)
					: document.getElementById(t.id)
				).innerHTML = this.getSectionInnerHTML(
					e.sections[t.id],
					t.selector
				);
			}),
			setTimeout(() => {
				this.open();
			});
	}
	updateCartCount(e) {
		document.querySelectorAll(".m-cart-count-bubble").forEach((t) => {
			e > 0
				? ((t.textContent = e), t.classList.remove("m:hidden"))
				: t.classList.add("m:hidden");
		});
	}
	getCart() {
		return fetchJSON(this.rootUrl + "cart.json");
	}
	onCartDrawerUpdate(e = !0) {
		fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
			.then((e) => e.text())
			.then((t) => {
				this.getSectionsToRender().forEach((r) => {
					if ("cart-items" === r.block) {
						(r.selector
							? document.querySelector(r.selector)
							: document.getElementById(r.id)
						).innerHTML = this.getSectionInnerHTML(t, r.selector);
					} else if (e) {
						(r.selector
							? document.querySelector(r.selector)
							: document.getElementById(r.id)
						).innerHTML = this.getSectionInnerHTML(t, r.selector);
					}
				});
			})
			.catch((e) => {}),
			this.getCart().then((e) => {
				this.classList.toggle("m-cart--empty", 0 === e.item_count),
					this.updateCartCount(e.item_count);
			});
	}
	getSectionInnerHTML(e, t = ".shopify-section") {
		return new DOMParser().parseFromString(e, "text/html").querySelector(t)
			.innerHTML;
	}
	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "[data-minimog-cart-items]",
				block: "cart-items",
			},
			{
				id: "cart-drawer",
				selector: "[data-minimog-cart-discounts]",
				block: "cart-footer",
			},
			{
				id: "cart-drawer",
				selector: "[data-cart-subtotal]",
				block: "cart-footer",
			},
			{
				id: "cart-drawer",
				selector: "[data-minimog-gift-wrapping]",
				block: "cart-footer",
			},
		];
	}
	getSectionDOM(e, t = ".shopify-section") {
		return new DOMParser().parseFromString(e, "text/html").querySelector(t);
	}
	setActiveElement(e) {
		this.activeElement = e;
	}
	initializeUpsellSection() {
		const drawer = document.getElementById("cart-drawer__upsell");
    if (drawer) {
      drawer.innerHTML = `
        <div class="cart-drawer__upsell-inner">
          <div class="cart-drawer__media">
            <img class="cart-drawer__image" src="${drawer.getAttribute("data-product-image")}">
          </div>
          <div class="cart-drawer__content">
            <div class="cart-drawer__title">
              ${drawer.getAttribute("data-product-title")}
            </div>
            <div class="cart-drawer__price">
            ${drawer.getAttribute("data-product-price")}
            </div>
            <div class="cart-drawer__button">
              <product-form data-product-id="${drawer.getAttribute("data-product-id")}">
                <form method="post" action="/cart/add" accept-charset="UTF-8" class="product-card-form" enctype="multipart/form-data" data-product-id="${drawer.getAttribute("data-product-id")}" novalidate="novalidate">
                  <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                  <input hidden="" name="id" required="" value="${drawer.getAttribute("data-product-variantId")}" data-selected-variant="">
                  <button class="m-add-to-cart m-spinner-button m:w-full m-button m-button--white" name="add" aria-label="${drawer.getAttribute("data-product-buttonText")}">
                  <span class="m-spinner-icon">
                    <svg class="animate-spin m-svg-icon--medium" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                  <span class="m-add-to-cart--text" data-atc-text="">
                    ${drawer.getAttribute("data-product-buttonText")}
                  </span>
                  </button>
                  <input type="hidden" name="product-id" value="${drawer.getAttribute("data-product-id")}">
                </form>
              </product-form>
            </div>
          </div>
        </div>
      `;
    }
	}
}
customElements.define("m-cart-drawer", MCartDrawer);
class MCartDrawerItems extends MCartTemplate {
	getSectionsToRender() {
		return [
			{
				id: "MinimogCartDrawer",
				section: "cart-drawer",
				selector: "[data-minimog-cart-items]",
			},
			{
				id: "MinimogCartDrawer",
				section: "cart-drawer",
				selector: "[data-minimog-cart-discounts]",
			},
			{
				id: "MinimogCartDrawer",
				section: "cart-drawer",
				selector: "[data-cart-subtotal]",
			},
			{
				id: "MinimogCartDrawer",
				section: "cart-drawer",
				selector: "[data-minimog-gift-wrapping]",
			},
		];
	}
}
customElements.define("m-cart-drawer-items", MCartDrawerItems);
